import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert.service';
import { ReportsService } from 'src/app/services/reports.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import * as _ from 'lodash';
import { RoleType } from 'src/enum/roletype';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { DivisionService } from 'src/app/services/division.service';
import { DepartmentBookingType } from 'src/enum/departmentbooking';
import { PaccsbookingService } from 'src/app/services/paccsbooking.service';
import { PaccsreportpopupComponent } from '../paccsreportpopup/paccsreportpopup.component';
import { DepartmentType } from 'src/enum/departmenttype';

@Component({
  selector: 'app-paccswisereport',
  templateUrl: './paccswisereport.component.html',
  styleUrls: ['./paccswisereport.component.scss']
})
export class PaccswisereportComponent implements OnInit {
  public DepartmentBookingType = DepartmentBookingType;
  public DepartmentType = DepartmentType;
  form: FormGroup;
  departmentList: any;
  vehicleList: any = [];
  url: string;
  clientId: any;
  scheduledEndmin: any;
  scheduledEndmax: any;
  vehicleRegNo: any;
  maxDate: Date;
  subdivisionList: any[];
  VehicleRegNoList: any[];
  VehicleTypeList: any[];
  filterVehicleTypeList: any[];
  public RoleEnumType = RoleType;
  roleId: number;
  vehicalyearList: any[];
  filtervehicalyearList: any;
  currentMonth: number;
  currentYear: number;
  curyear: any;
  financialyearId: any;
  GoList: any[];
  filterGoList: any;
  goId: any;
  SchemeList: any[];
  filterSchemeList: any;
  schemeId: any;
  ComponentList: any[];
  filterComponentList: any;
  componentId: any;
  isdisabledproduct: boolean;
  isdisabled: boolean = false;
  istabledisabled: boolean;
  languageType: any;
  districtList: any[];
  filterListdistrict: any[];
filterDepartmentList: any;
  districtId: number;
  isdisableddistrict: boolean;
  Department: any;
  usedepartmentId: number;
  paccslist: any[];
  @Input() districtData: any;
  filterpaccslist:any[];
  storeddistrictData: any;
  fullname: any;
  userId: number;
  paccsdisable: boolean ;
  goiddisable: boolean;
  schemedisable: boolean;



  constructor(
    private userSessionService: UserSessionService,
    private formBuilder: FormBuilder,
    public tripDialog: MatDialog,
    private reportsService: ReportsService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private cashBookingService: CashBookingService,
    private vehicleService: VehicleService,
    private divisionService: DivisionService,
    private paccsbookingService: PaccsbookingService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) {
    this.storeddistrictData = this.districtData;
    this.languageType = this.userSessionService.getLanguageType();
    this.roleId = this.userSessionService.roleId();
    // this.districtId = parseInt(this.userSessionService.getdistrictId());
    this.districtId = parseInt(this.userSessionService.getUserdistrictId());
    this.usedepartmentId = parseInt(this.userSessionService.getUserdepartmentId());
    this.userId = userSessionService.userId();


   }

  ngOnInit(): void {
    this.initializeValidators();
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.financialyearListLookup();
    this.getDistrict();
    this.getpaccs();
    // this.form.controls['componentId'].setValue(0);
    // this.form.controls['paccsid'].setValue(0);

  }

  initializeValidators() {
    
    this.form = this.formBuilder.group({
      financialyearId: ["", Validators.required],
      DepartmentId: [null, Validators.required],
      goId: [null, Validators.required],
      schemeId: [null, Validators.required],
      districtId: [null, Validators.required],
      paccsid: [0],
      componentId: [0],
    });
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  financialyearListLookup() {
    
    this.GoList = [];
    this.filterGoList = [];
    this.SchemeList = [];
    this.filterSchemeList = [];
    this.ComponentList = [];
    this.filterComponentList = [];
    // this.ImplementList = [];
    // this.filterImplementList = [];
    this.form.controls["DepartmentId"].setValue(null);
    this.form.controls["goId"].setValue(null);
    this.form.controls["componentId"].setValue(null);
    this.form.controls["schemeId"].setValue(null);
    this.vehicleService.vehicletargetFinancialyear(true).subscribe((result) => {
      this.vehicalyearList = [];
      this.vehicalyearList = result;
      this.filtervehicalyearList = result;
      var financialYear = "";
      if (this.currentMonth >= 0 && this.currentMonth <= 2) {
        financialYear =
          "FY " +
          ((this.currentYear - 1).toString() +
            "-" +
            this.currentYear?.toString().slice(-2));
      } else {
        financialYear =
          "FY " +
          (this.currentYear?.toString() +
            "-" +
            (this.currentYear + 1).toString().slice(-2));
      }
      this.curyear = this.filtervehicalyearList.find(
        (i) => i.value == financialYear
      );
      this.form.controls["financialyearId"].setValue(this.curyear.key);
      this.financialYearchange();
    });
  }
  financialYearchange() {
    this.DepartmentLookup();
  }
  DepartmentLookup() {
    this.GoList = [];
    this.filterGoList = [];
    this.SchemeList = [];
    this.filterSchemeList = [];
    this.ComponentList = [];
    this.filterComponentList = [];
    // this.ImplementList = [];
    // this.filterImplementList = [];
    this.form.controls["goId"].setValue(null);
    this.form.controls["componentId"].setValue(null);
    this.form.controls["schemeId"].setValue(null);
    this.form.controls["districtId"].setValue(0);
    this.form.controls["paccsid"].setValue(0);




    this.vehicleService.getDepartmentLookupData(true).subscribe((result) => {
      this.departmentList = [];
      this.departmentList = result.filter(i => i.key == DepartmentType.PaccsDepartment);
      this.filterDepartmentList = this.departmentList.slice();
      if (this.departmentList.length === 1) {
        this.form.controls["DepartmentId"].setValue(this.departmentList[0].key);
        this.getGoListbyId();
      }
    })
  }

  departmentChange() {
    this.getGoListbyId();

  }


  getGoListbyId() {
    this.SchemeList = [];
    this.filterSchemeList = [];
    this.ComponentList = [];
    this.filterComponentList = [];
    // this.ImplementList = [];
    // this.filterImplementList = [];
    this.form.controls["componentId"].setValue(null);
    this.form.controls["schemeId"].setValue(null);

    this.financialyearId, this.Department, true
    this.financialyearId = this.form.value.financialyearId;
    this.Department = this.form.value.DepartmentId;
    this.paccsbookingService.getGoListbyId(this.financialyearId, this.Department, true)
      .subscribe((result) => {
        this.GoList = [];
        this.GoList = result;
        this.filterGoList = result;
        if (this.filterGoList.length === 1) {
          this.form.controls["goId"].setValue(this.filterGoList[0].key);
          this.goiddisable = true;
          this.golistChange();
        } 
      });
  }

  golistChange() {
    this.getSchemaListbyId();
  }

  getSchemaListbyId() {
    this.ComponentList = [];
    this.filterComponentList = [];
    this.form.controls["componentId"].setValue(null);
    this.goId = this.form?.value?.goId;
    this.paccsbookingService
      .getSchemaListbyId(true, this.goId)
      .subscribe((result) => {
        this.SchemeList = [];
        this.SchemeList = result;
        this.filterSchemeList = result;
        if (this.filterSchemeList.length === 1) {
          this.form.controls["schemeId"].setValue(this.filterSchemeList[0].key);
          this.schemedisable = true;
          this.schemaListChange();
        } 
      });
  }

  schemaListChange() {
    this.getschemaListChange();
  }

  getschemaListChange() {
    this.form.controls['componentId'].setValue(0);
    this.schemeId = this.form.value.schemeId;
    this.goId = this.form.value.goId;
    this.paccsbookingService
      .editdbtcomponentallList(this.goId, this.schemeId, true)
      .subscribe((result) => {
        this.ComponentList = [];
        this.ComponentList = result;
        this.filterComponentList = result;
        this.filterComponentList = _.orderBy(
          this.filterComponentList,
          ["value"],
          ["asc"]
        );
        if (this.filterComponentList.length === 1) {
          this.form.controls["componentId"].setValue(
            this.filterComponentList[0].key
          );
        }
      });
  }

  getDistrict() {
    this.cashBookingService.districtData(1, true).subscribe(result => {
      if (result) {
        this.districtList = [];
        this.filterListdistrict = [];
        this.districtList = result;
        this.filterListdistrict = this.districtList.slice();
        const districtLength = this.districtList.length;
        if (districtLength === 1) {
          this.form.controls['districtId'].setValue(this.districtList[0].key);
          this.isdisableddistrict = true;
        }
        if (this.districtId) {
          this.form.controls['districtId'].setValue(this.districtId);
          this.isdisableddistrict = true;
        }

        if (this.roleId != this.RoleEnumType.PAACS) {
        }
      }
    });
  }

  districtchange(event){
    this.getpaccs();
  }

  getpaccs(){ 
    this.form.controls['paccsid'].setValue(0);
    let districtid = this.form.value.districtId ? this.form.value.districtId : this.districtId
    this.paccsbookingService.getpaccslist(districtid, true).subscribe(res =>{
      this.paccslist = res;
      this.filterpaccslist = this.paccslist.slice();
      const paccsLength = this.paccslist.length;
        if (paccsLength === 1) {
          this.form.controls['paccsid'].setValue(this.paccslist[0].key);
          // this.getBlock();
        }
        if(this.roleId == this.RoleEnumType.PAACS){
          if(this.userId){
            this.form.controls['paccsid'].setValue(this.userId);
            this.paccsdisable = true;
          }
        }
      
    })
  }
  

  showReport(){
    if (this.form.valid) {
      
      const data = {
        districtId : this.form.value.districtId,
        paccsId : this.form.value.paccsid >0  ? this.form.value.paccsid : 0,
        componentId: this.form.value.componentId >0  ? this.form.value.componentId : 0,
        // componentIdvalue:  _.find(this.ComponentList, ['key', (this.form.value.componentId)])?.value,
        // financialyearId: this.form.value.financialyearId,
        // schemeId:this.form.value.schemeId,
        reportType: 26
      }
      const dialogRef = this.tripDialog.open(PaccsreportpopupComponent, {
        autoFocus: false,
        disableClose: true,
        width: '90%',
        height: '90%',
        panelClass: 'mat-dialog-report',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }

  clear(){
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.initializeValidators();
    this.maxDate = new Date();
    this.scheduledEndmax = new Date();
    this.financialyearListLookup();
    this.getDistrict();
    this.getpaccs();
    // this.districtchange(event);
  }

  

}
